<template>
  <v-dialog
    v-model="localShow"
    max-width="800"
    content-class="ai-confidence-dialog"
    persistent
    @click:outside.stop
  >
    <v-card class="confidence-card">
      <v-card-title
        class="text-h6 white--text purple"
        style="position: relative"
      >
        <v-icon class="mr-6" color="white">mdi-robot-confused-outline</v-icon>
        Response Confidence
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="closeDialog">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <div class="d-flex align-center mb-4">
          <div class="confidence-score-container mr-4">
            <div class="confidence-score">
              {{ confidenceData?.confidence_score || 0 }}/10
            </div>
            <div class="confidence-label text-caption">Confidence Score</div>
          </div>
          <v-divider vertical class="mx-2"></v-divider>
          <div class="confidence-notes pa-2">
            {{
              confidenceData.confidence_notes ||
              'No confidence notes available.'
            }}
          </div>
        </div>

        <v-card outlined class="mb-4">
          <v-card-title class="text-subtitle-1"
            >Confidence Factors</v-card-title
          >
          <v-card-text class="pa-0">
            <v-list dense>
              <v-list-item
                v-for="(item, index) in confidenceOutput"
                :key="index"
              >
                <v-list-item-avatar>
                  <v-avatar
                    size="32"
                    :color="getConfidenceColor(item.confidence)"
                    class="white--text"
                  >
                    {{ item.confidence }}
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.value }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                    Source: {{ formatSource(item.source) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <v-card
          v-if="lowConfidenceReasons.length > 0"
          outlined
          color="red lighten-5"
        >
          <v-card-title class="text-subtitle-1"
            >Low Confidence Reasons</v-card-title
          >
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(reason, index) in lowConfidenceReasons"
                :key="index"
              >
                <v-list-item-icon>
                  <v-icon color="red">mdi-alert-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ reason }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AiConfidenceDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    confidenceData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    localShow: {
      get() {
        return this.show
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
    confidenceOutput() {
      return this.confidenceData?.confidance_output || []
    },
    lowConfidenceReasons() {
      return this.confidenceData?.low_confidence_reasons || []
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    getConfidenceColor(score) {
      if (score >= 8) return 'green lighten-1'
      if (score >= 5) return 'yellow'
      return 'red lighten-1'
    },
    formatSource(source) {
      return source
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
  },
}
</script>

<style scoped>
.ai-confidence-dialog {
  z-index: 999 !important;
}

.confidence-card {
  border-radius: 8px;
  overflow: hidden;
}

.confidence-score-container {
  text-align: center;
  min-width: 100px;
}

.confidence-score {
  font-size: 24px;
  font-weight: bold;
}

.confidence-label {
  color: #757575;
}

.confidence-notes {
  font-style: italic;
  color: #616161;
  line-height: 1.4;
  flex-grow: 1;
}
</style>
